import { DateTime } from "luxon";

export const Person = ({ person, toggleHide, isHidden }) => {
  return (
    <li
      className="flex justify-between items-center px-4 py-3 hover:bg-gray-50 transition"
      key={person.personId}
    >
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-gray-800">
          {person.firstName} {person.lastName}
        </div>
        <div className="text-sm text-gray-500">
          Last Check-in:{" "}
          {DateTime.fromISO(person.checkins[0].date).toFormat("MMMM dd, yyyy")}
        </div>
      </div>

      <span className="ml-4 px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded">
        {person.session}
      </span>
      <span className="ml-2 px-2 py-1 text-xs font-medium bg-red-100 text-red-800 rounded">
        {person.weeksSinceLastCheckin} weeks
      </span>
      <button
        className={`ml-4 px-3 py-1 text-xs font-semibold rounded border transition ${
          isHidden
            ? "bg-green-100 text-green-700 border-green-300 hover:bg-green-200"
            : "bg-white text-green-700 border-green-300 hover:bg-green-100"
        }`}
        onClick={() => toggleHide(person.personId)}
      >
        {isHidden ? "Unhide" : "Hide"}
      </button>
    </li>
  );
};
